import spfetch from './spfetch';

let colorsByUri = new Map();
const queue = [];
const batchSizeLimit = 50;

export function getColors(uri) {
  return colorsByUri.get(uri) || null;
}

export default async function fetchColors(uri) {
  if (!uri) return null;
  if (colorsByUri.has(uri)) return colorsByUri.get(uri);

  let resolve;
  let reject;
  // Steal `resolve` and `reject` function from promise to be control it from
  // the outside when eg. batching
  const promise = new Promise((_resolve, _reject) => {
    resolve = _resolve;
    reject = _reject;
  });
  promise.resolve = resolve;
  promise.reject = reject;
  colorsByUri.set(uri, promise);

  // These are batchable, so if this was the uri of its kind, set of a timeout
  // which will gather all uris of this type and look them up in maxium batch
  // sizes in the next tick.
  if (queue.push(uri) === 1) {
    setTimeout(function takeBatch() {
      const batch = queue.splice(0, batchSizeLimit);
      if (!batch.length) return;

      spfetch(
        `https://spclient.wg.spotify.com/colorextractor/v1/extract-presets?format=json&${new URLSearchParams(
          batch.map((uri) => ['uri', uri])
        )}`
      ).then(({ entries = [] }) => {
        const entriesByUri = Object.fromEntries(
          entries.map((entry) => [entry?.uri, entry])
        );

        batch.forEach((uri, i) => {
          const entry = entriesByUri[uri];
          const resolve = colorsByUri.get(uri).resolve;
          const colors =
            entry?.color_swatches?.reduce((colors, { preset, color }) => {
              colors[preset] = int2hex(color);
              return colors;
            }, {}) || null;

          colorsByUri.set(uri, colors);
          if (resolve) resolve(colors);
        });

        takeBatch();
      });
    });
  }

  return promise;
}

function int2hex(int) {
  var r = int >> 16;
  var g = (int >> 8) & 0xff;
  var b = int & 0xff;
  var bin = (r << 16) | (g << 8) | b;
  return `#${bin.toString(16).toUpperCase().padStart(6, '0')}`;
}
